export function TrustPilotRating() {
  return (
    <div className="w-full space-y-6 mb-8">
      <script
        src="https://static.elfsight.com/platform/platform.js"
        async
      ></script>
      <div
        className="elfsight-app-26f294cb-925f-45c7-858a-b4c38c53ba06"
        data-elfsight-app-lazy
      ></div>
    </div>
  );
}
